import axios from 'axios';
import config from './config';

const API_URL = `${config.API_BASE_URL}/Admins`;

// Existing functions...
export const registerAdmin = async (adminData) => {
  try {
    const response = await axios.post(API_URL, adminData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const loginAdmin = async (Number, Password) => {
  try {
    const response = await axios.post(`${API_URL}/login`, { Number, Password });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchAdmins = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateAdmin = async (id, adminData) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, adminData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteAdmin = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// NEW: Password Reset API Functions
export const initiatePasswordReset = async (Number, OldPassword) => {
  try {
    const response = await axios.post(`${API_URL}/password-reset/initiate`, { 
      Number, 
      OldPassword 
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyResetCode = async (Number, Code) => {
  try {
    const response = await axios.post(`${API_URL}/password-reset/verify-code`, { 
      Number, 
      Code 
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (Number, NewPassword, ConfirmPassword) => {
  try {
    const response = await axios.post(`${API_URL}/password-reset/reset`, { 
      Number, 
      NewPassword, 
      ConfirmPassword 
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};